import React, { useEffect, useState } from "react";
import { Menu, X, Smartphone } from "lucide-react";
import Logo from "./Logo";
import { track } from "@/lib/analytics";

const APP_URL = process.env.REACT_APP_APP_URL || "https://app.cemedeiros.com.br";

const NAV_LINKS = [
  { href: "/palavra-de-hoje", label: "Palavra do Dia" },
  { href: "/sobre", label: "Sobre" },
  { href: "/instituto", label: "Instituto" },
  { href: "/livros", label: "Livros" },
  { href: "/planos", label: "Planos" },
  { href: "/series", label: "Séries" },
  { href: "/sermoes", label: "Sermões" },
  { href: "/videos", label: "Vídeos" },
  { href: "/semana-de-oracao", label: "Oração" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      style={{ top: "calc(var(--promo-bar-height, 0px) + var(--weekly-banner-height, 0px))" }}
      className={`fixed left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-white/85 border-b border-[#E5E7EB]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 h-20 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="text-[0.78rem] uppercase tracking-[0.22em] text-[#111827] hover:text-[#C5A059] transition-colors duration-300 font-medium"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2.5">
          <a
            href={APP_URL}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="nav-cta-app"
            onClick={() => track("app_open", { source: "navbar" })}
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-[0.68rem] uppercase tracking-[0.2em] font-medium text-[#0B1E36] hover:text-[#C5A059] border border-[#0B1E36]/20 hover:border-[#C5A059] px-3 py-2.5 transition-colors duration-300"
          >
            <Smartphone size={13} strokeWidth={1.7} />
            App
          </a>
          <a
            href="/palavra-de-hoje"
            data-testid="nav-cta-devocional"
            className="btn-primary-gold text-xs whitespace-nowrap"
            style={{ padding: "0.65rem 1.25rem" }}
          >
            Devocional de Hoje
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-[#0B1E36]"
          aria-label="Alternar menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-[#E5E7EB]"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.22em] text-[#111827]"
              >
                {link.label}
              </a>
            ))}
            <a
              href={APP_URL}
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => {
                setOpen(false);
                track("app_open", { source: "mobile_menu" });
              }}
              data-testid="mobile-nav-cta-app"
              className="inline-flex items-center justify-center gap-2 text-xs uppercase tracking-[0.22em] text-[#0B1E36] border border-[#0B1E36]/25 px-4 py-3 mt-2"
            >
              <Smartphone size={14} strokeWidth={1.6} />
              Acessar o App
            </a>
            <a
              href="/palavra-de-hoje"
              onClick={() => setOpen(false)}
              className="btn-primary-gold text-xs"
            >
              Devocional de Hoje
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
